var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFusee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 144,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26264F",
    d: "M76.928 65.659s-1.287.192-1.418.819-.265 1.29.251 3c.517 1.711.459 2.44 1.081 2.552.622.11 1.835-4.445.086-6.372Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M76.833 63.85c-.01.125-.471 1.53-.736 2.328a.772.772 0 0 0 .294.878.938.938 0 0 0 1.28-.201c.514-.67 1.257-1.675 1.638-2.363l-2.476-.641Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M89.521 90.398s13.535 20.512-4.378 47.779c-1.668 2.54-5.462 2.283-6.79-.452l-8.462-17.421a11.057 11.057 0 0 1-.327-8.917l5.895-14.815 14.062-6.174Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M57.572 56.58S37.884 41.923 9.808 58.431c-2.616 1.538-2.562 5.354.089 6.83l16.882 9.406a10.94 10.94 0 0 0 8.853.801l15.051-5.123 6.888-13.767Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M91.402 88.608s13.535 20.512-4.378 47.779c-1.669 2.54-5.463 2.283-6.791-.452l-8.462-17.421a11.056 11.056 0 0 1-.326-8.917l5.894-14.815 14.063-6.174Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M59.452 54.788s-19.687-14.655-47.764 1.853c-2.615 1.538-2.561 5.354.09 6.83l16.881 9.406a10.94 10.94 0 0 0 8.854.801l15.05-5.123 6.889-13.767Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M82.825 11.403c25.903-19.693 62.215-6.028 62.228-5.979.048.016 11.714 37.14-9.25 62.058-19.015 22.601-56.002 35.694-63.084 38.048-.762.253-1.986.574-2.312-.162-6.347-14.31-16.18-24.19-28.785-30.453-.698-.347-.295-1.533-.012-2.26 2.678-6.88 17.678-43.36 41.215-61.252Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M92.466 48.19c14.48-10.915 25.615-3.989 39.429-13.328 5.044-3.41 10.866-9.273 15.229-20.221 2.072 12.61 3.155 35.636-11.321 52.842-19.015 22.602-56.002 35.695-63.084 38.049-.762.253-1.986.574-2.312-.162-3.207-7.23-7.304-13.327-12.198-18.4 5.168-2.156 9.04-4.84 12-7.512 11.938-10.773 9.063-21.324 22.256-31.269Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M127.421 22.209c-7.731-8.184-17.572-16.001-26.895-19.35 19.237-5.122 38.641.56 43.416 2.168a2.249 2.249 0 0 1 1.449 1.533c1.345 4.872 5.967 24.623-.147 43.633-2.3-8.48-10.093-19.8-17.824-27.984h.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m147.124 14.64.029.178.049.303.048.307.045.294.049.33.042.284.05.353.039.276c.018.124.034.249.051.374l.036.267.051.397.032.258.05.416.03.253.05.433a315.26 315.26 0 0 1 .075.7l.025.24.047.471.022.232.044.49.02.226.042.507.017.22a42.995 42.995 0 0 1 .054.738c.013.178.025.358.036.538l.014.21a48.947 48.947 0 0 1 .042.757 99.79 99.79 0 0 1 .06 1.351l.007.192c.006.199.013.399.018.6l.005.182a62.308 62.308 0 0 1 .026 1.596l.002.642v.168l-.004.655-.003.16c-.003.223-.006.445-.011.669l-.004.155a79.337 79.337 0 0 1-.023.828c-.008.231-.016.463-.027.696-.001.047-.004.093-.006.14-.01.236-.022.471-.034.708l-.008.132a60.198 60.198 0 0 1-.051.847 63.024 63.024 0 0 1-.122 1.597l-.01.112c-.022.252-.046.504-.072.757l-.01.102c-.026.256-.053.514-.082.772l-.01.09a113.008 113.008 0 0 1-.103.868l-.105.8-.01.067c-.038.272-.077.544-.118.816l-.008.054a81.905 81.905 0 0 1-.138.872c-.047.283-.095.566-.146.849l-.003.02a61.39 61.39 0 0 1-1.979 8.003c-1.47-5.42-5.185-11.999-9.692-18.179 4.043-3.602 8.234-8.998 11.572-17.372Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M119.898 65.61c9.455-9 9.049-24.84-.908-35.379-9.956-10.539-25.693-11.786-35.148-2.786-9.456 9-9.05 24.84.907 35.38 9.956 10.539 25.693 11.786 35.149 2.785Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M92.466 48.19c11.816-8.907 21.405-5.935 32.04-9.614 4.066 9.41 2.576 20.198-4.609 27.036-9.456 9-25.192 7.753-35.149-2.786a29.272 29.272 0 0 1-2.25-2.686c2.094-4.061 4.796-8.053 9.968-11.95Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M118.394 64.018c8.667-8.25 8.294-22.769-.832-32.429-9.126-9.66-23.55-10.803-32.218-2.553-8.667 8.25-8.294 22.769.832 32.429 9.126 9.66 23.55 10.803 32.218 2.553Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M116.264 61.763c7.55-7.187 7.225-19.835-.725-28.25-7.95-8.415-20.515-9.41-28.065-2.224-7.55 7.187-7.226 19.834.724 28.25 7.95 8.415 20.516 9.41 28.066 2.224Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M70.912 106.015c2.58-2.456-2.04-11.552-10.321-20.317-8.281-8.764-17.085-13.879-19.665-11.423-2.58 2.456 2.041 11.552 10.322 20.317 8.28 8.765 17.084 13.879 19.664 11.423Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m55.048 84.628 6.435 6.811a12.302 12.302 0 0 1 2.258 13.517l-1.954 4.314a2.444 2.444 0 0 1-4.006.675L36.44 87.357c-1.196-1.266-.734-3.344.884-3.981l4.396-1.73a12.19 12.19 0 0 1 13.327 2.982Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M60.383 110.884c2.435-2.317-1.132-10.06-7.965-17.294-6.834-7.233-14.348-11.219-16.782-8.901-2.435 2.317 1.132 10.06 7.965 17.293 6.834 7.234 14.348 11.219 16.782 8.902Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M57.414 107.74c1.85-1.761-.86-7.645-6.054-13.143-5.194-5.497-10.904-8.526-12.755-6.765-1.85 1.76.86 7.645 6.055 13.143 5.194 5.497 10.904 8.526 12.754 6.765Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M92.466 48.19c10.049-7.576 18.488-6.559 27.329-8.348 3.43 7.592 2.291 16.382-3.531 21.924-7.55 7.186-20.115 6.19-28.065-2.224a23.264 23.264 0 0 1-2.995-3.931c1.758-2.507 4.026-4.982 7.262-7.422Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED572F",
    d: "M45.915 127.796C37.702 136.024 0 144 0 144s7.96-37.77 16.174-45.998c8.208-8.228 25.399-12.107 33.612-3.878 8.214 8.228 4.343 25.444-3.871 33.672Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA902F",
    d: "M45.036 121.847c-6.33 6.341-35.38 12.487-35.38 12.487s6.133-29.104 12.463-35.445c6.324-6.347 19.569-9.333 25.898-2.992 6.33 6.341 3.343 19.61-2.986 25.95h.005Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BD31",
    d: "M45.513 116.295c-4.928 4.937-27.564 9.725-27.564 9.725s4.779-22.677 9.707-27.614c4.928-4.937 15.25-7.267 20.183-2.33 4.934 4.937 2.608 15.277-2.326 20.219Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE269",
    d: "M45.002 110.604c-3.223 3.228-18.013 6.352-18.013 6.352s3.125-14.816 6.341-18.044c3.223-3.228 9.966-4.748 13.188-1.52 3.222 3.229 1.7 9.984-1.516 13.212Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 96.507,
    x2: 71.054,
    y1: 127.507,
    y2: 100.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 119.896,
    x2: 83.697,
    y1: 65.614,
    y2: 27.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 46.38,
    x2: 20.925,
    y1: 74.445,
    y2: 47.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 98.388,
    x2: 72.935,
    y1: 125.717,
    y2: 98.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 22.795,
    x2: 93.585,
    y1: 64.098,
    y2: 48.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 93.127,
    x2: 99.123,
    y1: 84.581,
    y2: -29.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 101.925,
    x2: 107.921,
    y1: 85.042,
    y2: -29.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 156.231,
    x2: 111.334,
    y1: 39.739,
    y2: -7.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 141.425,
    x2: 143.672,
    y1: 41.607,
    y2: -1.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 76.127,
    x2: 78.556,
    y1: 62.354,
    y2: 67.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 119.274,
    x2: 83.075,
    y1: 66.207,
    y2: 28.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 108.415,
    x2: 97.99,
    y1: 29.032,
    y2: 56.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 93.404,
    x2: 107.975,
    y1: 86.156,
    y2: 18.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 42.731,
    x2: 57.016,
    y1: 104.775,
    y2: 89.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB9E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDD7A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 65.044,
    x2: 40.232,
    y1: 106.424,
    y2: 80.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 51.568,
    x2: 38.287,
    y1: 91.103,
    y2: 115.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 50.713,
    x2: 40.619,
    y1: 92.707,
    y2: 111.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 96.282,
    x2: 110.853,
    y1: 86.775,
    y2: 19.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusee);
export default __webpack_public_path__ + "static/media/fusee.321f5103aa5611e5516897bf2cc49a70.svg";
export { ForwardRef as ReactComponent };